/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface MemberSavingsOutputDto { 
    productId?: number;
    productName?: string | null;
    amount?: number;
    openingBalance?: number;
    accountNumber?: string | null;
    blockedAmount?: number;
    accountStatus?: string | null;
    startDate?: string | null;
    maturityDate?: string | null;
    tenure?: number | null;
    periodType?: string | null;
    productType?: string | null;
    interestRateCalculationMethod?: string | null;
    fdMaturityConfiguration?: string | null;
    fdMaturityConfigurationId?: number;
    creditAccount?: string | null;
    creditAccountId?: number | null;
    debitAccount?: string | null;
    debitAccountId?: number | null;
    interestRate?: number;
    interestAmount?: number;
    lockInDuration?: number | null;
    lockInDurationTypeId?: number | null;
    isLockInPeriodOver?: boolean | null;
    interestTillDate?: number;
    maturityAmount?: number;
    referenceAccountId?: number | null;
    referenceAccountNumber?: string | null;
}

